module.exports = __webpack_public_path__ + "img/about-17.85bd1f94.png";